import { render, staticRenderFns } from "./EnviarDinero.vue?vue&type=template&id=535fd4f8&"
import script from "./EnviarDinero.vue?vue&type=script&lang=js&"
export * from "./EnviarDinero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports